export class Author {

    constructor(Name: string) {
        this.Name = Name;
    }

    Name: string;
}
